const images = {
  fvlite_background: require('../images/fvlite_background.png'),
  fvlite_logo: require('../images/FVlite_logo.png'),
  avatar: require('../images/Default.png'),
  anet: require('../images/anet.png'),
  signupCompleteIcon: require('../images/icon-signup-complete.png'),
  stars: require('../images/_ _ _ _ _ _.png'),
  profilePic: require('../images/Profile Pic.png'),
  guestmodeBackground: require('../images/shutterstock_90267736.png'),
  expired: require('../images/Expired.png'),
  room_joining: require('../images/room-joining.png'),
  error: require('../images/error.png'),
  fvlite_auto_trial_background: require('../images/pc_bg.png'),
  anets_logo: require('../images/anets_logo.png'),
  fvlite_auto_trial_logo: require('../images/lfv_logo.png'),
  fvlite_auto_trial_background_mobile: require('../images/smp_bg.png'),
  fvlite_auto_trial_background_pad: require('../images/tbl_bg.png'),
  successImage: require('../images/Success image.png'),
  creditCards: require('../images/credit_card.png'),
  campaign1Image: require('../images/campaign1.png'),
  campaign2Image: require('../images/campaign2.png'),
  giftIcon: require('../images/gift-icon.png'),
  visa: require('../images/visa.png'),
  amex: require('../images/amex.png'),
  discover: require('../images/discover.png'),
  diners: require('../images/diners.png'),
  mastercard: require('../images/mastercard.png'),
  menuIcon: require('../images/menu-button.png'),
  quetionMark: require('../images/question-mark.svg'),
  sendIcon: require('../images/send.svg'),
  editIcon: require('../images/pencil.svg'),
  editBookIcon: require('../images/edit.png'),
  editBookIconDisabled: require('../images/edit-disabled.png'),
  pencilOutline: require('../images/pencil-outline.svg'),
  addOutline: require('../images/add-outline.svg'),
  calendar: require('../images/calendar.png'),
  clock: require('../images/clock.png'),
}

export default images



// WEBPACK FOOTER //
// src/config/images.js